import { SearchFilters } from '@cinch-nx/data-search'
import { getOrderedUrlPathSegmentFilters } from '../get-ordered-url-path-segment-filters/get-ordered-url-path-segment-filters'
import { transformFilterMapToString } from '../transform-filter-map-to-string/transform-filter-map-to-string'

export const getPathSegmentFiltersString = (
  pathSegmentFilters: Partial<SearchFilters>,
  formattedMake?: string,
  formattedModel?: string,
  formattedTrim?: string,
  formattedBodyType?: string,
  hasMatchingVehicleRecentlyBeenInStock?: boolean,
): string => {
  const titleOrderedFilterArray =
    getOrderedUrlPathSegmentFilters(pathSegmentFilters)

  if (
    titleOrderedFilterArray.size === 0 ||
    hasMatchingVehicleRecentlyBeenInStock === false
  )
    return ''

  const title = transformFilterMapToString(
    titleOrderedFilterArray,
    formattedMake,
    formattedModel,
    formattedTrim,
    formattedBodyType,
  )

  return title.trim()
}
